<template>
   <div :class="`header page-theme-${theme} header-${fixed ? 'fixed' : ''}`">
      <div @click="switchPopup()" class="page-theme">
        
        <div :class="`page-back page-back-${firstVisitAnimation ? 'first-visit' : ''}`">
          <div class="logo-compensation"/>
          <Navigation :alternative="true"/>
        </div>
        
        <div class="page-front">
          <div class="logo-compensation"/>
          <Navigation/>
        </div>
      </div>
      <ul class="navigation-menu navigation-lang font-grotesque uppercase">
        <li @click="switchLang(0)" :class="`navigation-menu-li navigation-menu-lang navigation-lang-${lang === 0 ? 'active' : ''} uppercase navigation-menu-li-active`">  <router-link :to="detectUrl()">ru</router-link>
        </li>
        <li @click="switchLang(1)" :class="`navigation-menu-li navigation-menu-lang navigation-lang-${lang === 1 ? 'active' : ''} uppercase navigation-menu-li-active`">   <router-link :to="detectUrl('eng')">en</router-link>
        </li>
      </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Navigation from '@/components/Navigation';

export default {
  name: 'heady',
  components: {
    Navigation,
  },
  mounted() {
    window.addEventListener('scroll', this.controlScrollMenu);
  },
  data() {
    return {
      fixed: false,
    };
  },
  methods: {
    detectUrl(lang) {
      const path = window.location.pathname.replace('eng/', '');
      return `/${lang || ''}${path}`;
    },
    controlScrollMenu() {
      const pageScroll = window.scrollY || document.documentElement.scrollTop;
      this.fixed = pageScroll > 10 && !this.mobile;
    },
    switchPopup() {
      this.$store.dispatch('popupState', false);
    },
    switchLang(lang) {
      this.$store.commit('SWITCH_LANG', lang);
    },
  },
  computed: mapGetters({
    firstVisitAnimation: 'firstVisitAnimation',
    mobile: 'mobile',
    theme: 'theme',
    lang: 'lang',
  }),
};
</script>

<style>
@keyframes show{
  from, 50%{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
.header{
  transform: translate3d(0, 20px, 0);
  transition: all .3s ease-in-out;
  /*white-space: nowrap;*/
  position: fixed;
  height: 100px;
  z-index: 1000;
  width: 100%;

  .app-low & {
    position: absolute;
  }

  .logo-sotbi{
    opacity: 0;
  }

  &-background{
    transition: background .3s ease-in-out;
    position: absolute;
    height: 29px;
    width: 100%;
    left: 0;
    top: 0;
  }

  &-fixed{
    transform: translate3d(0, 0, 0);
    height: 30px;

    .header-background{
      background: rgba(255,255,255,.9);
    }

    &-white,
    &-dark{
      transition: all .3s ease-in-out;
    }

    .phone{
      opacity: 0 !important;
    }
    .logo-sotbi{
      opacity: 1;
    }

    &-back{
      transform: translate3d(0, -50px, 0);
      transition: all .3s ease-in-out;
      position: absolute;
      height: 80px;
      width: 100%;
      opacity: 0;
      z-index: 0;
      left: 0;
      top: 0;
    }
  }


  &.page-theme-white{
    &.header-fixed{
      .header-fixed-white{
        transform: translate3d(0, 0, 0);
        transition-delay: 1.8s;
        opacity: 1;
        z-index: 1;
      }
      .page-front{
        background: rgba(255,255,255,.75);
        animation: show 2s ease-in-out;
      }
    }
  }

  &.page-theme-dark{
    .page-front{
      pointer-events: none;
      animation: none;
      opacity: 0;
    }

    &.header-fixed{
      .header-fixed-dark{
        transform: translate3d(0, 0, 0);
        transition-delay: 1.8s;
        min-width: 100%;
        opacity: 1;
        z-index: 1;
      }

      .page-back{
        background: rgba(2,15,52,.75);
        animation: show 2s ease-in-out;
      }
    }
  }

  .popup-open &{
    .page-front,
    .page-back{
      background: rgba(2, 12, 49, 0.5)!important;
      margin-left: 0;
      max-width: 100%;
      width: 100%;

      @media (min-width: $mediaMini) {
        padding-left: $whitePanel;
      }
    }

    /*.page-back{
      background: rgba(82, 206, 255, 0.7) !important;
    }*/
  }


  .page-theme{
    visibility: visible;
    overflow: hidden;
    position: fixed;
    height: 50px;
    z-index: 20;
    left: 0;
    top: 0;

    .app-low & {
      position: absolute;
    }
  }

  .page-back,
  .page-front{
    max-width: $whitePageMaxWide;
    width: $whitePageWide;
    visibility: visible;
    min-height: 32px;
    overflow: hidden;
    height: initial;

    &-first-visit{
      opacity: 0;
    }
  }

  .navigation{
    &-lang{
      /*display: none !important;*/
      position: absolute;
      border-bottom: 0;
      z-index: 999;
      right: 18px;
      top: 5px;

      @media (max-width: $mediaTiny) {
        right: 6px;
      }

      @media (max-width: 400px) {
        right: 0;
      }

      li{
        @media (max-width: $mediaMini) {
          display: block;
        }
      }

      a{
        border-bottom-color: rgba(255,255,255,.3);
        color: white;
        &:hover{
          color: #23a1d1;
          border-bottom-color: rgba(26,161,209,.3);
        }
      }
      &-active{
        border-bottom: 0;
        a{
          &,
          &:hover{
            text-decoration: none;
            border-bottom: 0;
            cursor: text;
            color: white;
          }
        }
      }
    }
  }

  .page-front{
    @media (min-width: $mediaMini) {
      padding-left: $whitePanel;
    }
    @media (min-width: $mediaMob) {
      .navigation{
        margin-left: -$whitePanel;
      }
    }
  }

  .page-back{
    @media (min-width: $mediaMini) {
      margin-left: $whitePanel;
    }
    &,
    .navigation{
      @media (max-width: $mediaMob) {
        max-width: 100%;
        width: 100%;
      }
    }

    .navigation{
      @media (min-width: $mediaMob) {
        margin-left: -$whitePanel;
      }
      background: transparent;
      @media (max-width: $mediaLaptop) {
        white-space: normal;
      }
      li{
        a{
          color: white;
        }
      }
      .phone{
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Heady.vue